__turbopack_context__.v({
  "bannerContent": "heroBanner-module-scss-module__-J-eUa__bannerContent",
  "betterthatBanner": "heroBanner-module-scss-module__-J-eUa__betterthatBanner",
  "contentWrapper": "heroBanner-module-scss-module__-J-eUa__contentWrapper",
  "customBatn": "heroBanner-module-scss-module__-J-eUa__customBatn",
  "imageContent": "heroBanner-module-scss-module__-J-eUa__imageContent",
  "licenseInfo": "heroBanner-module-scss-module__-J-eUa__licenseInfo",
  "textContent": "heroBanner-module-scss-module__-J-eUa__textContent",
});
